import { configureStore } from '@reduxjs/toolkit'
import appSessionStore from '@/lib/redux/app-session-slice'
import cartStore from '@/lib/redux/cart-slice'
import checkoutStore from '@/lib/redux/checkout-slice'
import modalsStore from '@/lib/redux/modals-slice'
import selectedProductStore from '@/lib/redux/selected-product-slice'

export const makeStore = () => {
  return configureStore({
    reducer: {
      modals: modalsStore,
      selectedProduct: selectedProductStore,
      cart: cartStore,
      checkout: checkoutStore,
      appSession: appSessionStore,
    },
  })
}

// Infer the type of makeStore
export type AppStore = ReturnType<typeof makeStore>
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<AppStore['getState']>
export type AppDispatch = AppStore['dispatch']
